import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useDeleteCategories } from '../../queries/use-delete-categories';

type CategoryDeleteConfirmDialogProps = {
    categoryId?: string;
    templateId: string;
    isOpen: boolean;
    onClose: () => void;
};

function CategoryDeleteConfirmDialog({ isOpen, categoryId, templateId, onClose }: CategoryDeleteConfirmDialogProps): JSX.Element {
    const deleteCategoryQuery = useDeleteCategories(templateId);

    function deleteProcedure(): void {
        deleteCategoryQuery.mutate(
            { ids: categoryId ? [categoryId] : [] },
            {
                onSuccess: () => {
                    onClose();
                    toastNotification('success', `Procedure category deleted!`);
                },
                onError: () => {
                    toastNotification('error', `Procedure category cannot be deleted!`);
                },
            }
        );
    }

    return (
        <Dialog
            title="Delete Category"
            description={`Do you want to delete this category? Procedures within this category will be uncategorised.`}
            onClose={onClose}
            onPrimaryActionClick={deleteProcedure}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Delete"
            secondaryAction="Cancel"
            type="error"
            isLoading={deleteCategoryQuery.isLoading}
        />
    );
}

export default CategoryDeleteConfirmDialog;
